import { StrictMode } from "react";
import ReactDOM from "react-dom";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

// STYLES
import "./styles.css";

// COMPONENTS
// MOBILE
// import MobileFirstComp from "./components/mobile/firstComp/firstComp";
import MobileSecondComp from "./components/mobile/secondComp/secondComp";

// DESKTOP
import DesktopFirstComp from "./components/desktop/firstComp/firstComp";
import DesktopSecondComp from "./components/desktop/secondComp/secondComp";
import ShopComp from "./components/shopComp/shopComp";
import Header from "./components/header/header";
import Banner from "./components/banner/banner";
import MovingText from "./components/movingText/movingText";
import Footer from "./components/footer/footer";

import img1 from "./images/firstComp/images/img1.webp";
import img2 from "./images/firstComp/images/img2.webp";
import img3 from "./images/firstComp/images/img3.webp";
import img4 from "./images/firstComp/images/img4.webp";
import img5 from "./images/firstComp/images/img5.webp";
import img6 from "./images/firstComp/images/img6.webp";
import img7 from "./images/firstComp/images/img7.webp";
import img8 from "./images/firstComp/images/img8.webp";
import video1 from "./videos/vid1.mp4";
import video2 from "./videos/vid2.mp4";
import video3 from "./videos/vid3.mp4";
import videoSlider from "./videos/videoSlider.mp4";
import part3img1 from "./images/secondComp/slider/img1.webp";
import part3img2 from "./images/secondComp/slider/img2.webp";
import part3img3 from "./images/secondComp/slider/img3.webp";
import part3img4 from "./images/secondComp/slider/img4.webp";
import flakes from "./images/secondComp/flakes.svg";
import special from "./images/secondComp/special.svg";
import HorizontalScroll from "./horizontal-scroll";
import styled, { createGlobalStyle } from "styled-components";

export default function App() {
  window.scrollTo({
    top: 0
    //  behavior: "smooth"
  });
  useEffect(() => {
    scroll.scrollToTop();
  });

  const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: sans-serif;
  }
`;

  const Main = styled.main``;

  const HorizontalSection = styled.section`
    position: relative;
    width: 100%;
    min-height: 100vh;
  `;

  const BumperSection = styled.section`
    text-align: center;
    padding: 128px 16px;
    background-color: #efefef;
    height: 800px;
  `;

  const CardsContainer = styled.div`
    position: relative;
    height: 100%;
    /* width: 90%;
  margin-left: 5%; */
    /* padding: 0 0 0 30vw; */
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
  `;

  const SampleCard = styled.div`
    position: relative;
    /* height: 100vh; */
    width: 100vw;
    /* background-color: #f3ede6; */
    margin-right: 60px;
    /* margin-left: 30px; */
    flex-shrink: 0;
  `;

  const SampleCards = React.memo(() =>
    Array(6)
      .fill(0)
      .map((_e, i) => <SampleCard key={`sampleCard-${i}`} />)
  );

  return (
    <>
      <GlobalStyle />
      <Main>
        <div className="main-body">
          <div className="main-wrapper">
            <Header />
            <Banner />
            <div className="part1">
              <div className="vid-wrap">
                <video
                  playsinline="true"
                  autoplay="true"
                  loop="true"
                  muted="true"
                  className="video-scroll"
                >
                  <source src={video1} type="video/mp4 " />
                </video>
                <div className="scroll-filter" />
              </div>
              <HorizontalSection className="section-wrapper">
                <HorizontalScroll>
                  <CardsContainer className="scroll-wrapper">
                    <SampleCard className="desktop-item">
                      {/* <MobileFirstComp /> */}
                      <DesktopFirstComp />
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img1})` }}
                    >
                      <img src={img1} alt="" />
                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          9:28AM
                          <div className="txt-bg" />
                        </div>
                        <div className="item-title">
                          <span>prețioasă</span>
                        </div>
                      </div> */}
                    </SampleCard>{" "}
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img2})` }}
                    >
                      <img src={img2} alt="" />

                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          10:03AM
                          <div className="txt-bg" />
                        </div>
                        <div className="item-title">
                          <span>contemplativă</span>
                        </div>
                      </div> */}
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img3})` }}
                    >
                      <img src={img3} alt="" />

                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          10:23AM
                          <div className="txt-bg" />
                        </div>

                        <div className="item-title">
                          <span>inspirată</span>
                        </div>
                      </div> */}
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img4})` }}
                    >
                      <img src={img4} alt="" />
                    </SampleCard>
                  </CardsContainer>
                </HorizontalScroll>
              </HorizontalSection>
              <div className="desktop-firstComp-text sep-1">
                <p>És mi lehetne jobb ajándék a gyémántnál - egy örökké tartó ajándék? 
                  <br /><br />
                  Fedezd fel a  {" "}
                </p>
                <span className="pure">Pure Diamonds</span>
                <p>kollekciót. </p>
              </div>
            </div>
            <div className="part2">
              {/* <div className="vid-wrap">
                <video
                  playsinline="true"
                  autoplay="true"
                  loop="true"
                  muted="true"
                  className="video-scroll"
                >
                  <source src={video2} type="video/mp4 " />
                </video>
                <div className="scroll-filter" />
              </div> */}
              <HorizontalSection className="section-wrapper">
                <HorizontalScroll>
                  <CardsContainer className="scroll-wrapper second-scroll-wrapper">
                    <SampleCard className="desktop-item remove-portrait"></SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img5})` }}
                    >
                      <img src={img5} alt="" />

                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          11:02AM
                          <div className="txt-bg" />
                        </div>

                        <div className="item-title">
                          <span>nerăbdătoare</span>
                        </div>
                      </div> */}
                    </SampleCard>{" "}
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img6})` }}
                    >
                      <img src={img6} alt="" />
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img7})` }}
                    >
                      <img src={img7} alt="" />
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img8})` }}
                    >
                      <img src={img8} alt="" />
                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          11:03AM
                          <div className="txt-bg" />
                        </div>

                        <div className="item-title">
                          <span>încântată</span>
                        </div>
                      </div> */}
                    </SampleCard>
                  </CardsContainer>
                </HorizontalScroll>
              </HorizontalSection>
              <div className="desktop-firstComp-text sep-2">
                <p>
                  Ékszerek - ez a hiteles és jelentőségteljes ajándék. Amit alig vársz, hogy viselj vagy ajándékozz.  {" "}
                </p>
                <span className="colored-bold">Mindig kivételes.</span>
              </div>
            </div>
            <div className="part3">
              <DesktopSecondComp />
              <MobileSecondComp />
            </div>
            <div className="part4">
              <HorizontalSection className="section-wrapper">
                <HorizontalScroll>
                  <CardsContainer className="scroll-wrapper second-scroll-wrapper">
                    <SampleCard className="desktop-item">
                      <div className="row3-text">közben...</div>
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img5})` }}
                    >
                      <img src={part3img1} alt="" />

                      {/* <div className="item-text">
                        <div className="txt-wrap">
                          11:20AM
                          <div className="txt-bg" />
                        </div>

                        <div className="item-title">
                          <span>extaz</span>
                        </div>
                      </div> */}
                    </SampleCard>{" "}
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img6})` }}
                    >
                      <img src={part3img2} alt="" />
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img7})` }}
                    >
                      <img src={part3img3} alt="" />
                    </SampleCard>
                    <SampleCard
                      className="desktop-item"
                      // style={{ backgroundImage: `url(${img8})` }}
                    >
                      <img src={part3img4} alt="" />
                      {/* <div className="item-text euphoria-txt">
                        <div className="txt-wrap">
                          11:22AM
                          <div className="txt-bg" />
                        </div>

                        <div className="item-title ">
                          <span>euforie</span>
                        </div>
                      </div> */}
                    </SampleCard>
                  </CardsContainer>
                </HorizontalScroll>
              </HorizontalSection>
              <div className="desktop-firstComp-text sep-2 desk-ContentRow4-text">
                <img
                  className="flakes-img"
                  src={flakes}
                  // ref={(el) => (flakeRef = el)}
                />
                <div className="special-text">
                  {/* <p>
                    E povestea mea, împărtășită cu tine, prin TEILOR. <br />
                  </p>
                  <img src={special} alt="" />{" "} */}
                  <p>
                  Idén a szeretet és az ajándékozás kéz a kézben jár. Válaszd ki azt az ajándékot, amely emlékezetes és örömet okoz.
                    {/* <br /> De Crăciun, fii asemenea unui diamant:{" "}
                    <b className="colored-bold">prețioasă</b> și{" "}
                    <b className="colored-bold">unică.</b> */}
                  </p>
                </div>
              </div>
            </div>

            <div className="third-container">
              <ShopComp />
              <MovingText />
            </div>
            <Footer />
          </div>
        </div>
      </Main>
    </>
  );
}
